import { render, staticRenderFns } from "./EditComanda.vue?vue&type=template&id=71f13a2c&scoped=true"
import script from "./EditComanda.vue?vue&type=script&lang=js"
export * from "./EditComanda.vue?vue&type=script&lang=js"
import style0 from "./EditComanda.vue?vue&type=style&index=0&id=71f13a2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f13a2c",
  null
  
)

export default component.exports